import React from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";

const LoggedInUser = () => {
    const isBusinessUser = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userServiceDetails?.isBusinessUser);
    const loggedInActiveAccount = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount ? state.loggedInUser.activeAccount : null
    );
    const LoggedInActiveUserName: string =
        loggedInActiveAccount && loggedInActiveAccount.firstName && loggedInActiveAccount.lastName
            ? loggedInActiveAccount.firstName + " " + loggedInActiveAccount.lastName
            : "";
    const businessName: string = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.businessName ? state.loggedInUser.businessName : ""
    );
    const loginUserAccountDisplayName: string = isBusinessUser ? businessName : LoggedInActiveUserName;

    return (
        <React.Fragment>
            <button
                type="button"
                className="btn-default btn-icon-left btn-pop-under user-button"
                style={{ display: "inline-flex" }}
                id="user-profile-btn"
                aria-expanded="false"
                aria-controls="user-profile-options"
            >
                <span className="btn-icon" aria-hidden="true">
                    <em className="las la-user"></em>
                </span>
                <span className="btn-text user-display-name-wrap" title={loginUserAccountDisplayName}>
                    <span className="sr-only">View</span>
                    {loginUserAccountDisplayName}
                </span>
                <span className="btn-helper" aria-hidden="true">
                    &nbsp;&nbsp;<em className="las la-angle-down"></em>
                </span>
            </button>
        </React.Fragment>
    );
};

export default LoggedInUser;
